import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/villa/Header";
import { Hero } from "@/components/villa/Hero";
import { About } from "@/components/villa/About";
import { Experiences } from "@/components/villa/Experiences";
import { Gallery } from "@/components/villa/Gallery";
import { Booking } from "@/components/villa/Booking";
import { Footer } from "@/components/villa/Footer";
import { Toaster } from "@/components/ui/sonner";
import { AdminApp } from "@/admin/AdminApp";

function HomePage() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#F8F5F0] text-[#2C302E] font-sans antialiased">
        <Header />
        <main>
          <Hero />
          <About />
          <Experiences />
          <Gallery />
          <Booking />
        </main>
        <Footer />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            classNames: {
              toast:
                "!rounded-none !border !border-[#2C302E]/15 !bg-[#F8F5F0] !text-[#2C302E] !font-light",
              title: "!font-serif !text-lg",
              description: "!text-sm !text-[#5C625E]",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
